module.exports = "<app-header></app-header>\n<app-weather></app-weather>\n"